import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";
import { categories } from "@/mocks/categories";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `text-sm font-medium transition-colors ${
      isActive ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-compass-3-line text-lg"></i>
          </span>
          <span className="text-lg font-extrabold tracking-tight text-foreground-950">网址导航</span>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          <NavLink to="/" end className={linkClass}>
            首页
          </NavLink>
          <div
            className="relative"
            onMouseEnter={() => setCatOpen(true)}
            onMouseLeave={() => setCatOpen(false)}
          >
            <NavLink to="/category/news" className={linkClass}>
              <span className="inline-flex items-center gap-0.5">
                分类
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </NavLink>
            {catOpen ? (
              <div className="absolute left-0 top-full pt-3">
                <div className="grid w-[440px] grid-cols-2 gap-1 rounded-lg border border-background-200 bg-background-50 p-3">
                  {categories.map((c) => (
                    <Link
                      key={c.id}
                      to={`/category/${c.id}`}
                      className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                    >
                      <i className={`${c.icon} text-primary-500`}></i>
                      {c.name}
                    </Link>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
          <NavLink to="/about" className={linkClass}>
            关于
          </NavLink>
        </nav>

        <div className="ml-auto hidden w-full max-w-xs md:block lg:max-w-sm">
          <SearchBar size="sm" />
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden"
        >
          <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {mobileOpen ? (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="px-4 py-4">
            <SearchBar size="sm" onSubmitted={() => setMobileOpen(false)} />
            <div className="mt-4 flex flex-col gap-1">
              <Link
                to="/"
                onClick={() => setMobileOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-50"
              >
                首页
              </Link>
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-50"
              >
                关于
              </Link>
            </div>
            <p className="mt-4 px-3 text-xs font-medium text-foreground-500">热门分类</p>
            <div className="mt-2 grid grid-cols-2 gap-1">
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-2 rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-50"
                >
                  <i className={`${c.icon} text-primary-500`}></i>
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}